import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalResult } from '@shared/models/ModalResult';

@Component({
  standalone: false,
  selector: 'app-fcsc-result-dependencies',
  templateUrl: './fcsc-result-dependencies.component.html',
  styleUrls: ['./fcsc-result-dependencies.component.scss'],
})
export class FcscResultDependenciesComponent {
  constructor(public activeModal: NgbActiveModal) {}

  ignoreDependencies(): void {
    this.activeModal.close(ModalResult.DEPENDENCIES_IGNORE);
  }

  editDependencies(): void {
    this.activeModal.close(ModalResult.DEPENDENCIES_EDIT);
  }

  loadDataAndIdentifyFlashware() {
    this.activeModal.close(ModalResult.DEPENDENCIES_LOAD);
  }
}
